<po-loading-overlay
  [hidden]="!isLoading"
  p-text="Buscando Produtos..."
></po-loading-overlay>

<font class="po-font-title po-m-5">Área técnica</font>

<div class="po-md-10 po-m-5">
  <po-container>
    <div class="po-font-text-bold">Acervo Técnico</div>
    <po-divider></po-divider>
    <po-table
      p-height="200"
      p-hide-columns-manager
      p-sort="true"
      p-auto-collapse
      [p-columns]="columnsAcervo"
      [p-items]="itemsAcervo"
      [p-striped]="true"
    ></po-table>
  </po-container>
</div>

<div class="po-md-10 po-m-5">
  <po-container>
    <po-input
      class="po-md-10 po-md-3"
      name="filtro"
      p-label="Consulta produtos"
      [(ngModel)]="produtoFiltro"
      p-placeholder="Informe o código do produto ou parte da descrição para consulta"
      p-icon="po-icon po-icon-search"
    >
    </po-input>

    <po-button
      class="po-md-3 po-md-3"
      p-label="Buscar"
      [p-loading]="isLoading"
      [p-disabled]="isLoading"
      (p-click)="BuscaProduto()"
      p-icon="po-icon po-icon-search"
    >
    </po-button>

  </po-container>
</div>

<div class="po-row po-m-5">
  <po-container class="po-md-5">
    <div class="po-font-text-bold">Produtos</div>
    <po-divider></po-divider>
    <po-table
      p-height="400"
      p-hide-columns-manager
      p-sort="true"
      p-auto-collapse
      [p-columns]="columnsProdutos"
      [p-items]="optionsProdutos"
      [p-striped]="true"
    ></po-table>
  </po-container>

  <po-container class="po-md-5" style="text-align: center;">
    <figure style="margin: 0;"> <!-- margin: 0 para remover a margem padrão do figure -->
        <img
          style="max-width: 100%; height: auto; display: block; margin: 0 auto;"
          src="assets/mapa.png"
          alt="Mapa Distribuição Brasil"
        />
        <!-- <figcaption style="margin-top: 10px; font-size: 0.9em; color: #555;">
            Mapa Distribuição Brasil
        </figcaption> -->
    </figure>
</po-container>

  <po-container class="po-md-5" *ngIf="isPecas">
    <div class="po-font-text-bold" *ngIf="isPecas">Produtos similares</div>
    <div style="color: firebrick">
      *Informe o código completo no campo de consulta para exibir os similares
    </div>
    <po-divider></po-divider>
    <po-table
      *ngIf="isPecas"
      p-height="400"
      p-hide-columns-manager
      p-sort="true"
      p-auto-collapse
      [p-columns]="columnsSimilar"
      [p-items]="itemsSimilar"
      [p-striped]="true"
    ></po-table>
  </po-container>
</div>
